import { createFileRoute, Outlet, Link } from "@tanstack/react-router";
import { WifiOff } from "lucide-react";
import { useFeltServiceWorker, useIsOffline } from "@/hooks/use-offline";

export const Route = createFileRoute("/felt")({
  head: () => ({
    meta: [
      { title: "Feltmodus | VERQO" },
      {
        name: "description",
        content:
          "VERQO feltmodus – raske fagberegninger på byggeplass, med store trykkflater og høy kontrast.",
      },
      { property: "og:title", content: "VERQO feltmodus" },
      {
        property: "og:description",
        content: "Raske fagberegninger på byggeplass, tilpasset mobil og hansker.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: FeltLayout,
});

function FeltLayout() {
  useFeltServiceWorker();
  const offline = useIsOffline();

  return (
    <div className="min-h-dvh bg-background">
      <header className="sticky top-0 z-10 border-b border-border bg-background/95 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-2xl items-center justify-between px-4">
          <Link to="/felt" className="text-lg font-bold tracking-tight">
            VERQO <span className="text-muted-foreground">felt</span>
          </Link>
          <Link
            to="/dashboard"
            className="flex h-12 min-w-12 items-center justify-center text-sm text-muted-foreground"
          >
            Full app
          </Link>
        </div>
        {offline && (
          <div
            role="status"
            className="flex items-center justify-center gap-2 border-t border-amber-500/40 bg-amber-500/15 px-4 py-2 text-sm font-medium text-amber-700"
          >
            <WifiOff className="h-4 w-4" /> Uten nett – beregninger virker fortsatt
          </div>
        )}
      </header>
      <main className="mx-auto max-w-2xl px-4 py-4 pb-16">
        <Outlet />
      </main>
    </div>
  );
}
